import { action } from "typesafe-actions";
import { ExtDdaAccount } from "types";

export const ADD_SELECTION_ACCOUNTS = "ADD_SELECTION_ACCOUNTS";

export const addSelectionAccounts = (payload: ExtDdaAccount[]) =>
  action(ADD_SELECTION_ACCOUNTS, payload);
